import React from "react";

import { vars as stylingVars } from "@app/styles";

import { SpinnerSizes } from "./style-vars";

export type SpinnerIconProps = React.AllHTMLAttributes<HTMLDivElement> & {
  dimensions: number;
};

export const SpinnerIcon = ({ dimensions, children }: SpinnerIconProps) => {
  const styling = {
    "--spinner-size": `${dimensions / SpinnerSizes.factor}px`,
    position: "absolute",
    display: "inline-block",
    top: `${dimensions / SpinnerSizes.top}px`,
    width: "var(--spinner-size)",
    height: "var(--spinner-size)",
    backgroundColor: stylingVars.colorPurple,
    borderRadius: "50%",
  } as React.CSSProperties;

  return <div style={styling}>{children}</div>;
};
